import { Skeleton } from '@app/components/various/Skeleton';

export const AddressSummarySkeleton = () => {
  return (
    <div>
      <div className="mb-3 max-w-56">
        <Skeleton type="text" size="medium" />
      </div>
      <div className="max-w-[60%] space-y-1">
        <Skeleton type="rectangle" aspectRatio={1 / 4} />
      </div>
    </div>
  );
};
